import React from "react";
import {Sortable} from './Sortable';

export const SortableIterator = Item => (props) => {
    return <Sortable {...props} render={Item} />
};